import { ApiResponse, AppliedCoupon, OrderCoupon } from "../../../types";
import { getRequestWithAuth, patchRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);


export interface Coupon{
    getCoupon(session_code:string,totalValue:string,city_id:string): Promise<ApiResponse<OrderCoupon[]>>
    applyCoupon(coupon:OrderCoupon, toatlValue:number, totalCartOrderValue:number, session_code:string,city_id:string):Promise<ApiResponse<AppliedCoupon>>
    removeCoupon(session_code:string):Promise<any>
   
}

const coupon: Coupon = {
     getCoupon(session_code,totalValue,city_id) {
    return getRequestWithAuth(api.COUPON_LIST, [session_code, String(totalValue),city_id])
  },

  applyCoupon(coupon, totalValue, totalCartOrderValue, session_code,city_id) {

    const payload = {
      totalValue,
      totalCartOrderValue,
      coupon,
      city_id
    }
    return patchRequestWithAuth(api.COUPON_APPLY, payload, session_code,)
  },

  removeCoupon(session_code){
    return getRequestWithAuth(api.COUPON_REMOVE, session_code)
  }
   

}

export default coupon

